import type { ApiMessage, ApiMessageReplyInfo } from '../../api/types';

export function getMessageReplyInfo(message: ApiMessage): ApiMessageReplyInfo | undefined {
  const { replyInfo } = message;
  if (!replyInfo || replyInfo.type !== 'message') return undefined;
  return replyInfo;
}
